var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    ref: "textarea",
    attrs: { disabled: _vm.disabled },
    domProps: { value: _vm.value },
    on: {
      keydown: [
        function($event) {
          if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13)) {
            return null
          }
          if (!$event.ctrlKey) {
            return null
          }
          _vm.$emit("submit")
        },
        function($event) {
          if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13)) {
            return null
          }
          if (!$event.metaKey) {
            return null
          }
          _vm.$emit("submit")
        }
      ],
      input: function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-485d8c11", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485d8c11","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/RichTextarea.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-485d8c11","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/RichTextarea.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13